import Storage from "@react-native-async-storage/async-storage";

export default Storage;
